import React, { useState, useRef, useEffect } from 'react';
import { Table, Button, Image, Modal, Form, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import noSignature from './no-signature.png';
import SignaturePad from "react-signature-canvas";
import "./sigCanvas.css";
import Licenses from './Licenses';
import Customize from './Customize'

import axios from 'axios';
const constants = require('./constants');


const Profile = props => {
    const [imageURL, setImageURL] = useState(null);

    const sigCanvas = useRef({});

    const [showLicPlain, setShowLicPlain] = useState(false);
    const handleShowLicPlain = () => { if (showLicPlain) { setShowLicPlain(false); } else { setShowLicPlain(true); } }

    const [showEditTitle, setShowEditTitle] = useState(false);
    const handleShowEditTitle = () => { if (showEditTitle) { setShowEditTitle(false); } else { setShowEditTitle(true); } }


    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const clear = () => sigCanvas.current.clear();

    const { t } = useTranslation();

    const parentEventSend = props.parentEventCb;
    //const [showLics, setShowLics] = useState(false);
    //const handleCloseLics = () => setShowLics(false);
    //const handleShowLics = () => setShowLics(true);

    //const [newTitle, setNewTitle] = useState("");

    var tmpNewTitle = "";


    //function changeHandler(event) {
    //    console.log("Change handler", event.target.name, "value:", event.target.value);
    //    setNewTitle({ value: event.target.value });
    //}


    function submitHandler(event) {
        event.preventDefault();

        //console.log("submitHandler", newTitle, "tmp", tmpNewTitle);
        setProfTitle(tmpNewTitle);

        let data = { imageurl: null, jobtitle: tmpNewTitle };

        axios.post(constants.SERVER_URL + '/api/profile', data, { headers: { 'content-type': 'application/json' } })
            .then(resp => {
                if (resp.status === 200) {
                    console.log("Jobtitle updated");
                } else {
                    console.log("Jobtitle not updated");
                }
            })
            .catch(err => {
                if(!checkAxiosRespSession(err)) {
                    console.log("Profile submitHandler error", err);
                }
            });


        //setNewTitle('');
        handleShowEditTitle();

    }

    const EditTitle = () => { //NOSONAR Used on button
        return (
            <>
                <br />
                <Form onSubmit={submitHandler}>
                    <label htmlFor="newTitle">{t("New Job Title")}:</label><br />
                    <FormControl
                        type="text"
                        id="newTitle"
                        name="newTitle"
                        maxLength={90}
                        placeholder={t("New Job Title")}
                        required
                        onChange={(event) => { tmpNewTitle = event.target.value; }}
                    />
                    <Button type="submit">{t("Save")}</Button>
                </Form>
                <p><br /></p>
            </>
        );
    }

    const save = () => {

        let b64ImageUrl = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");

        //setImageURL(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
        //console.log("save: ------>", b64ImageUrl);

        if(sigCanvas.current.isEmpty()) {
            b64ImageUrl = "DELETE";
        }

        let data = { imageurl: b64ImageUrl, jobtitle: null };

        axios.post(constants.SERVER_URL + '/api/profile', data, { headers: { 'content-type': 'application/json' } })
            .then(resp => {
                if (resp.status === 200) {
                    console.log("Signature updated");
                    if(b64ImageUrl === "DELETE") {
                        setImageURL(noSignature);
                    } else {
                        setImageURL(b64ImageUrl);
                    }
                } else {
                    console.log("Signature not updated");
                }
            })
            .catch(err => {
                if(!checkAxiosRespSession(err)) {
                    console.log("Profile save error", err);
                }
            });
        setShow(false);
    }


    const signatureImageStyle = {
        border: '1px solid black',
        background: 'white',
        padding: '5px',
        maxHeight: '200px',
        maxWidth: '320px'
    }

    const [profName, setProfName] = useState('');
    const [profEmail, setProfEmail] = useState('');
    const [profTitle, setProfTitle] = useState('');

    const setProfileView = (data) => {
        //console.log("setProfileView", data)
        setProfName(data.firstname + " " + data.lastname);
        setProfEmail(data.email);
        setProfTitle(data.jobtitle);
        //console.log("setting image: ------------------------>", data.signimage);
        if (data.signimage) {
            setImageURL(data.signimage);
        } else {
            setImageURL(noSignature);
        }
    }

    const checkFetchRespSession = (resp)=> {
        if (!resp.ok) {
          if(resp.status === 401) {
            parentEventSend("SESSION_EXPIRED");
          }
          throw Error(resp.statusText);
        }
        return resp;
      }

    const checkAxiosRespSession = (err)=> {
        if(err.response && err.response.status === 401) {
          parentEventSend("SESSION_EXPIRED");
          return true;
      }
      return false;
    }

    useEffect(() => {
        fetch(constants.SERVER_URL + "/api/profile", { method: 'get' })
            .then(resp => checkFetchRespSession(resp)) 
            .then(resp => resp.json())
            .then(data => setProfileView(data))
            .catch(error => console.log("Fetching profile error:", error));
    });


    return (
        <div>
            <Customize.Style />
            <p><br></br> </p>
            <h1 id='title'>{t("Profile Settings")}</h1>

            <Table>
                <tbody>
                    <tr><td>{t("Name")}</td><td>{profName}</td></tr>
                    <tr><td>{t("Email")}</td><td>{profEmail}</td></tr>
                    <tr><td>{t("Job Title")}</td><td>{profTitle} <Button variant="primary" size="sm" onClick={handleShowEditTitle}>{t("Edit")}</Button>{showEditTitle ? <EditTitle /> : null}</td></tr>
                </tbody>
            </Table>



            <p>{t("Visual Signature")}</p>
            <Image src={imageURL} style={signatureImageStyle}>
            </Image>
            <p></p>

            <Button type="submit" onClick={handleShow}>{t("Change Visual Signature")}</Button>

            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Create New Visual Signature")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SignaturePad 
                        ref={sigCanvas}
                        canvasProps={{
                            className: "signatureCanvas",
                            width: "766px",
                            height: "300px"
                        }}
                    />
                    {/* Button to trigger save canvas image */}
                    <br />
                    <Button onClick={clear}>{t("Clear")}</Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={save}>
                        {t("Save Signature and Close")}
            </Button>
                    <Button variant="primary" onClick={handleClose}>
                        {t("Cancel")}
            </Button>
                </Modal.Footer>
            </Modal>


            <p><br /><br /><br /><br /></p>
            {/*
      <h2>Logout eSignature</h2>
      <Button type="submit" onClick={logout}>Logout</Button>
      */}
            <p><br /><br /><br /><br /></p>

            <h2>{t("Component Licenses")}</h2>

            <Button type="submit" onClick={handleShowLicPlain}>{t("Show Component License Information")}</Button>

            <div>
                {showLicPlain ? <Licenses /> : null}
            </div>


        </div>
    );


}

export default (Profile);



